import * as React from 'react';

import ColumnLayout from '../layouts/ColumnLayout';
import AuthContext from '../contexts/AuthContext';
import PageContext from '../contexts/PageContext';
import PageComponent from '../components/PageComponent';

import '../pages/App.css';
import logo from '../logo.svg';

export default function App() {
  const authContext = React.useContext(AuthContext);
  const pageContext = React.useContext(PageContext);
  // authContext.onLogin authContext.onLogout

  const loggedIn = authContext.isLoggedIn;

  React.useEffect(() => {
    setTimeout(() => {
      if (loggedIn) {
        async function sessionCheck() {
          const res = await authContext.onSession(localStorage.getItem('token'));
          if (res) {
            pageContext.onReload();
          } else {
            authContext.onNoSession();
          } 
        }
        sessionCheck();
      }
    }, 500);

  }, [loggedIn])
  
  return (
    <div className="App">
      {!loggedIn && <ColumnLayout childs={[
          (<img src={logo} className="app-logo" alt="logo" />)
        ]} />}
      {loggedIn && <PageComponent />}
    </div>
  );
}
